import { render, staticRenderFns } from "./CardSlider.vue?vue&type=template&id=4c2c8414&"
import script from "./CardSlider.vue?vue&type=script&lang=js&"
export * from "./CardSlider.vue?vue&type=script&lang=js&"
import style0 from "./CardSlider.vue?vue&type=style&index=0&id=4c2c8414&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports